import Loader from "../Layout/loader";

import { useEffect, useState } from "react";
import axios from "axios";
import { TbReportSearch } from "react-icons/tb";
import ModalFechamento from "../PDVs/modalFechamento";
import ModalContent from "../PDVs/modalContent";

import {
  Chart as ChartJS,
  ArcElement,
  Tooltip,
  Legend,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
} from "chart.js";
import { Line } from "react-chartjs-2";
import { codigoEvento } from "../Utils/utils";

ChartJS.register(ArcElement, Tooltip, Legend);
ChartJS.register(CategoryScale, LinearScale, PointElement, LineElement, Title);
ChartJS.defaults.font.family = "Roboto, sans-serif";
ChartJS.defaults.font.size = 14;

function formatarDataGrafico(input) {
  // Divide em data e hora
  const [data, hora] = input.split(" ");
  const [ano, mes, dia] = data.split("/");

  // Monta no formato desejado
  return `${dia}/${mes} ${hora}h`;
}

function DashboardProduto(codProd) {
  const [isLoading, setIsLoading] = useState(true);
  const [data, setData] = useState(null);

  const [dataVendasHora, setDataVendasHora] = useState(null);

  const [total, setTotal] = useState(0);
  const [dataPieProdutos, setDataPieProdutos] = useState(null);
  const [mapFormasPgto, setMapFormasPgto] = useState(new Map());
  const [dataPieFormaPgto, setDataPieFormaPgto] = useState(null);
  const [hasData, setHasData] = useState(false);

  const [displayDetalhesVendasHoras, setDisplayDetalhesVendasHoras] =
    useState(false);
  const [maxTurno, setMaxTurno] = useState(0);
  const [isModalOpen, setModalOpen] = useState(false);

  const [currentPDV, setCurrentPDV] = useState(null);
  const [currentTurno, setCurrentTurno] = useState(null);

  const carregarDados = () => {
    setIsLoading(true);
    axios
      .get(`${process.env.REACT_APP_API_URL}/InfoProduto`, {
        headers: { auth: process.env.REACT_APP_API_TOKEN },
        params: {
          codproduto: codProd.codProd,
          codaluguel: codigoEvento(),
        },
      })
      .then((response) => {
        setData(response.data[0]);
        setIsLoading(false);

        let labelVendas = [];
        let valorVendas = [];
        let qtdeVendas = [];
        response.data[0].vendasHora.forEach((item) => {
          labelVendas.push(formatarDataGrafico(item.DATASTAT));
          valorVendas.push(item.TOTAL);
          qtdeVendas.push(item.QTDE);
        });
        setHasData(labelVendas.length > 0);

        setDataVendasHora({
          labels: labelVendas,
          datasets: [
            {
              label: "Valor Vendido",
              data: valorVendas,
              borderColor: "#0066CC",
              backgroundColor: "#0066CC",
              tension: 0.4,
              fill: true,
            },
            {
              label: "Unidades Vendidas",
              data: qtdeVendas,
              borderColor: "#008000",
              backgroundColor: "#008000",
              tension: 0.4,
              fill: true,
            },
          ],
        });

        let labelsProdutos = [];
        let valorProdutos = [];
        let valorOutros = 0;
        let indexAux = 0;
        response.data[0].vendasProdutos.forEach((item) => {
          if (indexAux < 10) {
            labelsProdutos.push(item.DESCRICAO);
            valorProdutos.push(Number(item.TOTAL));
          } else {
            valorOutros += Number(item.TOTAL);
          }
          indexAux++;
        });
        if (valorOutros > 0) {
          labelsProdutos.push("Outros");
          valorProdutos.push(valorOutros);
        }

        setDataPieProdutos({
          labels: labelsProdutos,
          datasets: [
            {
              label: "Valor Vendido",
              data: valorProdutos,
              backgroundColor: [
                "#FF0000",
                "#FF7F00",
                "#FFFF00",
                "#A0FF00",
                "#00CC00",
                "#008000",
                "#00CCCC",
                "#0066CC",
                "#0000CC",
                "#7F00FF",
                "#808080",
              ],

              borderWidth: 1,
            },
          ],
        });

        let mapFormasPgto = new Map();
        var totalPgtos = 0;
        response.data[0].vendasFormaPgto.forEach((item) => {
          mapFormasPgto.set(item.CODFORMAPGTO, item.TOTAL);
          totalPgtos = totalPgtos + Number(item.TOTAL);
        });

        //console.log("mapFormasPgto", mapFormasPgto);
        //console.log("totalPgtos", totalPgtos);

        setTotal(totalPgtos - (mapFormasPgto.get(4) || 0));

        setMapFormasPgto(mapFormasPgto);

        setDataPieFormaPgto({
          labels: [
            "Dinheiro",
            "Pix Tef",
            "Pix",
            "Crédito",
            "Débito",
            "POS",
            "Voucher",
          ],
          datasets: [
            {
              label: "Valor Vendido",
              data: [
                mapFormasPgto.get(1) || 0,
                mapFormasPgto.get(8) || 0,
                mapFormasPgto.get(9) || 0,
                mapFormasPgto.get(6) || 0,
                mapFormasPgto.get(5) || 0,
                mapFormasPgto.get(2) || 0,
                mapFormasPgto.get(7) || 0,
              ],
              backgroundColor: [
                "#00CC00", // Dinheiro - verde médio forte
                "#FF7F00", // Pix Tef - laranja vibrante
                "#0066CC", // Pix - azul forte
                "#FFFF00", // Crédito - amarelo vivo
                "#7F00FF", // Débito - violeta intenso
                "#FF0000", // POS - vermelho clássico
                "#808080", // Voucher - cinza neutro
              ],

              borderWidth: 1,
            },
          ],
        });
      })
      .catch((error) => {
        console.error("Erro na requisição:", error);
      });
  };

  function verInfoModal(pdv, turno, maxTurno) {
    setCurrentPDV(pdv);
    setCurrentTurno(turno);
    setMaxTurno(maxTurno);
    setModalOpen(true);
  }

  useEffect(() => {
    carregarDados();
  }, []);

  return (
    <div>
      {isLoading ? (
        <Loader />
      ) : (
        <div className="container mx-auto font-Roboto p-2">
          {hasData ? (
            <div className="grid grid-cols-1 md:grid-cols-6 gap-4 w-full">
              <div className="col-span-1 md:col-span-6 border border-gray-300 rounded-lg shadow p-4 space-y-4">
                <div className="w-full h-96">
                  <Line
                    data={dataVendasHora}
                    options={{
                      responsive: true,
                      maintainAspectRatio: false, // Para permitir altura fixa
                      layout: {
                        padding: 10,
                      },
                      plugins: {
                        legend: {
                          position: "bottom",
                          display: true,
                        },
                        tooltip: {
                          mode: "index",
                          intersect: true,
                          callbacks: {
                            label: function (tooltipItem) {
                              const datasetLabel =
                                tooltipItem.dataset.label || "";
                              let value = tooltipItem.formattedValue;

                              if (datasetLabel === "Valor Vendido") {
                                value = new Intl.NumberFormat("pt-BR", {
                                  style: "currency",
                                  currency: "BRL",
                                }).format(tooltipItem.raw);
                              }

                              return `${datasetLabel}: ${value}`;
                            },
                          },
                        },
                      },
                      animation: {
                        tension: {
                          duration: 500,
                          easing: "linear",
                          from: 0.05,
                          to: 0,
                          loop: false,
                        },
                      },
                      hover: {
                        mode: "nearest",
                        intersect: true,
                      },
                      scales: {
                        x: {
                          title: {
                            display: false,
                            text: "Data/Hora",
                          },
                        },
                        y: {
                          title: {
                            display: true,
                            text: "Vendas",
                          },
                          ticks: {
                            callback: function (value) {
                              return new Intl.NumberFormat("pt-BR", {
                                style: "currency",
                                currency: "BRL",
                              }).format(value);
                            },
                          },
                        },
                      },
                    }}
                  />
                </div>
                <div className="w-full rounded-md">
                  <button
                    onClick={() =>
                      setDisplayDetalhesVendasHoras(!displayDetalhesVendasHoras)
                    }
                    className="w-full text-left px-4 py-3 border-none focus:outline-none hover:bg-gray-200 hover:text-gray-800"
                  >
                    {displayDetalhesVendasHoras ? "−" : "+"} Ver Vendas por Hora
                  </button>
                </div>
                {/* Conteúdo do Accordion com Transição */}
                <div
                  className={`mt-4 text-sm text-gray-700 overflow-hidden transition-all duration-300 ease-in-out ${
                    displayDetalhesVendasHoras
                      ? "max-h-none opacity-100"
                      : "max-h-0 opacity-0"
                  }`}
                >
                  <div className="text-sm text-gray-700">
                    <div className="overflow-x-auto">
                      <table className="min-w-full table-auto">
                        <thead>
                          <tr className="bg-gray-100">
                            <th className="px-4 py-2 text-left">Horário</th>
                            <th className="px-4 py-2 text-right">Quantidade</th>
                            <th className="px-4 py-2 text-right">
                              Valor Total
                            </th>
                          </tr>
                        </thead>
                        <tbody>
                          {data.vendasHora.map((row, index) => (
                            <tr
                              key={index}
                              className={
                                index % 2 === 0 ? "bg-white" : "bg-gray-50"
                              }
                            >
                              <td className="px-4 py-2">
                                {formatarDataGrafico(row.DATASTAT)}
                              </td>
                              <td className="px-4 py-2 text-right">
                                {row.QTDE}
                              </td>
                              <td className="px-4 py-2 text-right">
                                {new Intl.NumberFormat("pt-BR", {
                                  style: "currency",
                                  currency: "BRL",
                                }).format(row.TOTAL)}
                              </td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </div>

              <div className="col-span-1 md:col-span-6 border border-gray-300 rounded-lg shadow p-4 space-y-4 max-h-none">
                <h2 className="font-Oswald text-center">
                  Vendas por Operador/Terminal
                </h2>
                <table className="min-w-full table-auto font-Roboto">
                  <thead>
                    <tr>
                      <th className="text-left">PDV</th>
                      <th className="text-left">Turno/Operador</th>
                      <th className="text-right">Quantidade</th>
                      <th className="text-right">Valor Total</th>
                    </tr>
                  </thead>
                  <tbody>
                    {data.vendasTurnoPDV.map((row, index) => (
                      <tr
                        key={index}
                        className={index % 2 === 0 ? "bg-white" : "bg-gray-50"}
                      >
                        <td>
                          <TbReportSearch
                            className="cursor-pointer"
                            size={28}
                            onClick={() =>
                              verInfoModal(row.PDV, row.TURNO, row.TURNO)
                            }
                          />
                          {row.PDV}
                        </td>
                        <td>
                          {row.TURNO} - {row.RESPONSAVEL}
                        </td>
                        <td className="text-right">{row.QTDE}</td>
                        <td className="text-right">
                          {new Intl.NumberFormat("pt-BR", {
                            style: "currency",
                            currency: "BRL",
                          }).format(row.TOTAL)}
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
              <ModalFechamento
                isOpen={isModalOpen}
                onClose={() => setModalOpen(false)}
              >
                <ModalContent
                  pdv={currentPDV}
                  turno={currentTurno}
                  maxTurno={maxTurno}
                  onClose={() => setModalOpen(false)}
                />
              </ModalFechamento>
            </div>
          ) : (
            <div className="flex justify-center items-center h-96">
              <h1 className="text-lg font-semibold text-gray-700">
                Nenhum dado encontrado para o período selecionado.
              </h1>
            </div>
          )}
        </div>
      )}
    </div>
  );
}

export default DashboardProduto;
